import { initServiceCatalog } from './init.js';
import './listing-loadmore.js';

initServiceCatalog();

const catalogCarouselTrack = new Swiper('.catalog-carousel__track', {
  loop: true,
  slidesPerView: 3,
  spaceBetween: 30,
  pagination: {
    el: '.catalog-carousel__pagination',
    clickable: true,
    bulletClass: 'catalog-carousel__bullet',
    bulletActiveClass: 'catalog-carousel__bullet--active',
  },
  breakpoints: {
    0: {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
            enabled: false
        }
    },
    768: {
        slidesPerView: 2,
        spaceBetween: 58,
        navigation: {
            enabled: false
        }
    },

    1200: {
        slidesPerView: 3,
        spaceBetween: 30,
        navigation: {
          nextEl: '.catalog-carousel__button--next',
          prevEl: '.catalog-carousel__button--prev',
        },
    }
  }
});